module.exports = __webpack_public_path__ + "img/icon_browse.4872c2f9.png";